import { CustomPalette } from "@type/CustomPalette";

export const customPalette: CustomPalette["custom"] = {
  red: {
    50: "#FFEBEE",
    100: "#FFCDD2",
    200: "#EF9A9A",
    300: "#E57373",
    400: "#EF5350",
    500: "#F44336",
    600: "#E53935",
    700: "#D32F2F",
    800: "#C62828",
    900: "#B71C1C",
  },
  purple: {
    50: "#E9EBFB",
    100: "#C7CCF6",
    200: "#A0ABF0",
    300: "#7789EA",
    400: "#566EE5",
    500: "#3053DF",
    600: "#2B4AD3",
    700: "#1E3FC7",
    800: "#1034BC",
    900: "#0020A4",
  },
  green: {
    50: "#E6F5ED",
    100: "#C4E5D2",
    200: "#9ED4B5",
    300: "#77C499",
    400: "#59B884",
    500: "#3AAC6F",
    600: "#339D64",
    700: "#2B8B58",
    800: "#26794C",
    900: "#195A37",
  },
  teal: {
    50: "#E2F4F2",
    100: "#B7E3DD",
    200: "#89D2C8",
    300: "#5BBFB2",
    400: "#3CB0A1",
    500: "#2AA290",
    600: "#269483",
    700: "#228372",
    800: "#1E7363",
    900: "#175747",
  },
  violet: {
    50: "#EEE8FF",
    100: "#D2C8F7",
    200: "#B3A4ED",
    300: "#947FE2",
    400: "#7B63DA",
    500: "#6149D1",
    600: "#5644CA",
    700: "#463CC1",
    800: "#3736B9",
    900: "#1A2BAA",
  },
  blue: {
    50: "#E3F2FD",
    100: "#BBDEFB",
    200: "#90CAF9",
    300: "#64B5F6",
    400: "#42A5F5",
    500: "#2196F3",
    600: "#1E88E5",
    700: "#1976D2",
    800: "#1565C0",
    900: "#0D47A1",
  },
  orange: {
    50: "#FFF4E4",
    100: "#FFE2BB",
    200: "#FFD090",
    300: "#FFBD66",
    400: "#FFAF4C",
    500: "#FFA23E",
    600: "#FA963B",
    700: "#F38837",
    800: "#EB7934",
    900: "#DF6430",
  },
  grey: {
    50: "#FAFAFA",
    100: "#F5F5F5",
    200: "#EEEEEE",
    300: "#E0E0E0",
    400: "#BDBDBD",
    500: "#9E9E9E",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
  },
  navy: {
    50: "#F0F8FF",
    100: "#E9F1FF",
    200: "#DFE6FC",
    300: "#CED6EB",
    400: "#AAB2C6",
    500: "#8A91A5",
    600: "#62697C",
    700: "#4F5668",
    800: "#313849",
    900: "#101827",
  },
  pink: {
    50: "#F9CCE3",
    100: "#F4A0D1",
    200: "#F080BE",
    300: "#E75EAC",
    400: "#E23C9A",
    500: "#E20074",
    600: "#B6005E",
    700: "#9B004E",
    800: "#B6005E",
    900: "#E20074",
  },
  deepBlue: {
    50: "#E8F1F8",
    100: "#C9DDED",
    200: "#A7C6E0",
    300: "#7DA8CD",
    400: "#4F86B2",
    500: "#2F6892",
    600: "#174E74",
    700: "#0D3E62",
    800: "#042F4F",
    900: "#003768",
  },
};
